/* eslint-disable no-tabs */
import React from 'react';
import { createSvgIcon } from '@mui/material/utils';

import rateReview from '@mui/icons-material/RateReview';
import outlinedRatingStar from '@mui/icons-material/StarBorderRounded';
import filledRatingStar from '@mui/icons-material/StarRounded';

const filledSingleRatingStar = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5551 1.24452L16.8858 7.84375L23.2962 8.47888C23.4488 8.49156 23.5946 8.54771 23.7163 8.64068C23.838 8.73365 23.9305 8.85955 23.9828 9.00347C24.0352 9.14738 24.0452 9.30329 24.0118 9.45274C23.9783 9.60218 23.9027 9.7389 23.7939 9.84671L18.5182 15.0761L20.4742 22.1821C20.5142 22.3328 20.5099 22.4918 20.4616 22.6401C20.4134 22.7884 20.3233 22.9196 20.2023 23.018C20.0813 23.1163 19.9344 23.1776 19.7794 23.1944C19.6244 23.2112 19.4678 23.1829 19.3285 23.1129L12.8295 19.8944L6.33943 23.1089C6.20012 23.1789 6.04354 23.2072 5.88853 23.1904C5.73351 23.1736 5.58665 23.1123 5.46562 23.014C5.34459 22.9157 5.25455 22.7845 5.20631 22.6362C5.15807 22.4879 5.1537 22.3288 5.19372 22.1781L7.1497 15.0721L1.87005 9.84273C1.76129 9.73492 1.68569 9.5982 1.6522 9.44876C1.61872 9.29931 1.62875 9.1434 1.68112 8.99949C1.73349 8.85557 1.82599 8.72967 1.94768 8.6367C2.06937 8.54373 2.21515 8.48758 2.36776 8.4749L8.77818 7.83976L12.1038 1.24452C12.1722 1.11093 12.2762 0.998803 12.4042 0.920507C12.5323 0.842211 12.6794 0.800781 12.8295 0.800781C12.9796 0.800781 13.1267 0.842211 13.2548 0.920507C13.3828 0.998803 13.4867 1.11093 13.5551 1.24452V1.24452Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
	'filledSingleRatingStar',
);

const outlinedSingleRatingStar = createSvgIcon(
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5551 1.24452L16.8858 7.84375L23.2962 8.47888C23.4488 8.49156 23.5946 8.54771 23.7163 8.64068C23.838 8.73365 23.9305 8.85955 23.9828 9.00347C24.0352 9.14738 24.0452 9.30329 24.0118 9.45274C23.9783 9.60218 23.9027 9.7389 23.7939 9.84671L18.5182 15.0761L20.4742 22.1821C20.5142 22.3328 20.5099 22.4918 20.4616 22.6401C20.4134 22.7884 20.3233 22.9196 20.2023 23.018C20.0813 23.1163 19.9344 23.1776 19.7794 23.1944C19.6244 23.2112 19.4678 23.1829 19.3285 23.1129L12.8295 19.8944L6.33943 23.1089C6.20012 23.1789 6.04354 23.2072 5.88853 23.1904C5.73351 23.1736 5.58665 23.1123 5.46562 23.014C5.34459 22.9157 5.25455 22.7845 5.20631 22.6362C5.15807 22.4879 5.1537 22.3288 5.19372 22.1781L7.1497 15.0721L1.87005 9.84273C1.76129 9.73492 1.68569 9.5982 1.6522 9.44876C1.61872 9.29931 1.62875 9.1434 1.68112 8.99949C1.73349 8.85557 1.82599 8.72967 1.94768 8.6367C2.06937 8.54373 2.21515 8.48758 2.36776 8.4749L8.77818 7.83976L12.1038 1.24452C12.1722 1.11093 12.2762 0.998803 12.4042 0.920507C12.5323 0.842211 12.6794 0.800781 12.8295 0.800781C12.9796 0.800781 13.1267 0.842211 13.2548 0.920507C13.3828 0.998803 13.4867 1.11093 13.5551 1.24452V1.24452Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
	'outlinedSingleRatingStar',
);

export {
	rateReview,
	filledSingleRatingStar,
	outlinedSingleRatingStar,
	outlinedRatingStar,
	filledRatingStar,
};
